"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _vue = _interopRequireDefault(require("vue"));
var _vueI18n = _interopRequireDefault(require("vue-i18n"));
var _zh = _interopRequireDefault(require("./lang/zh"));
var _en = _interopRequireDefault(require("./lang/en"));
var _locale = _interopRequireDefault(require("element-ui/lib/locale"));
var _en2 = _interopRequireDefault(require("element-ui/lib/locale/lang/en"));
var _zhCN = _interopRequireDefault(require("element-ui/lib/locale/lang/zh-CN"));
var _store = _interopRequireDefault(require("@/store"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //引入自定义语言配置
//引入UI框架语言配置---elementui
_locale.default.i18n(function (key, value) {
  return i18n.t(key, value);
}); //为了实现element插件的多语言切换
_vue.default.use(_vueI18n.default); // 全局注册国际化包

/**
 * 返回当前 lang
 */
function getLanguage() {
  return _store.default && _store.default.getters && _store.default.getters.language;
}
// 准备翻译的语言环境信息
var i18n = new _vueI18n.default({
  locale: getLanguage(),
  //将语言标识存入localStorage或sessionStorage中，页面刷新不会默认中文显示
  messages: {
    // 中文语言包
    zh: _objectSpread(_objectSpread({}, _zh.default), _zhCN.default),
    //英文语言包
    en: _objectSpread(_objectSpread({}, _en.default), _en2.default)
  },
  silentTranslationWarn: true,
  //解决vue-i18n黄色警告"value of key 'xxx' is not a string"和"cannot translate the value of keypath 'xxx'.use the value of keypath as default",可忽略
  globalInjection: true,
  // 全局注入
  fallbackLocale: "zh" // 指定的locale没有找到对应的资源或当前语种不存在时，默认设置当前语种为中文
});
var _default = exports.default = i18n;